import BtnCoustom from '../Components/ButtonCstoum';
import '../Style/Footer.css';
import { FaWhatsapp, FaFacebookF } from 'react-icons/fa';

function Footer() {
    return (
        <>
            <div className="container-fluid footer-main p-5 bg-dark text-white">
                <div className="row text-center text-lg-start">

                    {/* Column 1 - Logo and Button */}
                    <div className="col-lg-4 mb-4 mb-lg-0 d-flex flex-column align-items-center align-items-lg-start">
                        <h1 className="mb-3">Rami Ibrahim</h1>
                        <BtnCoustom />
                    </div>

                    {/* Column 2 - Links */}
                    <div className="col-lg-5  mb-lg-0 m-auto fw-bold">
                        
                            
                          <p className="small mt-4">© 2025 Rami Ibrahim. All rights reserved.</p>

                        
                    </div>

                    {/* Column 3 - Contact / Social */}
                    <div className="col-lg-3 d-flex flex-column align-items-center align-items-lg-start">
                        <h2 className="mb-3 m-auto">Stay Connected</h2>

                        {/* WhatsApp */}
                        <a
                            href="https://wa.me/201551212431"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-flex align-items-center mb-2 text-white text-decoration-none fw-bold m-auto"
                        >
                            <FaWhatsapp size={20} className="me-2 " />
                            <span>01551212431</span>
                            <p className=' text-white ms-4 m-0 p-1 fw-bold m-auto'>Egypt</p>
                        </a>

                        {/* Facebook */}
                        <a
                            href="https://www.facebook.com/ramiibra7im"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-flex align-items-center text-white text-decoration-none fw-bold m-auto"
                        >
                            <FaFacebookF size={20} className="me-2  " />
                            <span>Rami Ibrahim</span>
                        </a>
                    </div>

                </div>
            </div>
        </>
    );
}

export default Footer;
